export const Integrations = [{
  appName: 'Google Contacts',
  logo: 'https://f.hubspotusercontent20.net/hubfs/521324/blob-Nov-05-2020-01-21-38-81-PM.png'
}, {
  appName: 'Mailchimp',
  logo: 'https://hubspot-integrators-prod.s3.amazonaws.com/listing/236011.png'
}, {
  appName: 'Xero',
  logo: 'https://hubspot-integrators-prod.s3.amazonaws.com/listing/235997.png'
}, {
  appName: 'Aircall',
  logo: 'https://cdn2.hubspot.net/hubfs/875767/Aircall_Logo_Icon-1.png'
}, {
  appName: 'Airtable',
  logo: 'https://hubspot-integrators-prod.s3.amazonaws.com/listing/236654.png'
}, {
  appName: 'Microsoft Dynamics 365',
  logo: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/dynamics-home-logo-2-1.png'
}];